import React from 'react';
import * as styled from './button.styled';

export const Button: React.FC<{
    onClick: () => void;
    variant?: 'default' | 'link';
    className?: string;
    color?: 'white' | 'yellow';
}> = ({ children, className, color = 'white', onClick, variant = 'default' }) => {
    return variant === 'default' ? (
        <styled.Button className={className} onClick={onClick}>
            {children}
        </styled.Button>
    ) : (
        <styled.LinkButton className={className} color={color} onClick={onClick}>
            {children}
        </styled.LinkButton>
    );
};
